import { apiHolder } from 'api';
import { getIn18Text } from 'api';
const dataStoreApi = apiHolder.api.getDataStoreApi();
export const trackTypeMap = {
    private: 'personal',
    public: 'enterprise',
    share: 'share',
    recently: 'recently',
    cloudAtt: 'cloudAtt',
    normalAtt: 'normalAtt',
};
export const tabInterfaceMap = {
    private: 'personal',
    public: 'ent',
    share: 'personalShare',
    favorites: 'favorites',
};
export const DiskTipKeyEnum = {
    UNITABLE_CREATE_TIP: 'disk_recently_unitable_create_tip_showed',
    CREATE_OR_UPLOAD_TIP: 'disk_recently_create_tip_showed',
    DOC_CREATE_TIP: 'disk_doc_create_tip_showed',
    EXTERNAL_SHARE_TIP: 'disk_recently_external_share_tip_showed',
    WELCOME_TIP: 'disk_recently_welcome_tip_showed',
    RENEW_CLOUD_ATT_SUPPORTED_KNOWED_TIP: 'disk_renew_cloud_att_supported_knowed',
};
const DiskTipPriorityMap = {
    [DiskTipKeyEnum.CREATE_OR_UPLOAD_TIP]: 2,
    [DiskTipKeyEnum.UNITABLE_CREATE_TIP]: 5,
    [DiskTipKeyEnum.EXTERNAL_SHARE_TIP]: 10,
    [DiskTipKeyEnum.WELCOME_TIP]: 0,
    [DiskTipKeyEnum.DOC_CREATE_TIP]: -1,
};
export const getDiskGuideTipsInfo = () => Object.keys(DiskTipKeyEnum).reduce((prev, cur) => {
    var _a;
    const key = DiskTipKeyEnum[cur];
    prev[key] = {
        showed: ((_a = dataStoreApi.getSync(key)) === null || _a === void 0 ? void 0 : _a.data) === 'true',
        visiable: false,
        priority: DiskTipPriorityMap[key],
    };
    return prev;
}, {});
export const checkDiskGuideTipsPriority = (info, curKey) => {
    const curPriority = info[curKey].priority;
    if (curPriority === -1)
        return true;
    const keys = Object.keys(info);
    const res = !keys.some(key => {
        const item = info[key];
        return key !== curKey && item.visiable && item.priority < curPriority;
    });
    return res;
};
export const roleIdMap = {
    100: getIn18Text('GUANLIYUAN'),
    202: getIn18Text('SHANGCHUAN/XIAZAI'),
    201: getIn18Text('XIAZAI'),
    203: getIn18Text('CHAKAN'),
    204: getIn18Text('BIANJI'),
};
export const DiskAuthKeys = ['NETDISK_ORG', 'NETDISK_ACC', 'NETDISK_EXTERNAL_SHARE'];
export const DiskFullAuths = [
    {
        resourceId: '2',
        resourceLabel: 'NETDISK_ORG',
        resourceName: getIn18Text('QIYEKONGJIAN'),
        accessList: [{ accessId: '1', accessLabel: 'USE', accessName: getIn18Text('SHIYONGQUANXIAN') }],
    },
    {
        resourceId: '3',
        resourceLabel: 'NETDISK_ACC',
        resourceName: getIn18Text('GERENKONGJIAN'),
        accessList: [{ accessId: '1', accessLabel: 'USE', accessName: getIn18Text('SHIYONGQUANXIAN') }],
    },
    {
        resourceId: '5',
        resourceLabel: 'NETDISK_EXTERNAL_SHARE',
        resourceName: getIn18Text('DUIWAIFENXIANG'),
        accessList: [{ accessId: '1', accessLabel: 'USE', accessName: getIn18Text('SHIYONGQUANXIAN') }],
    },
];
export const transDiskPrivileges = (dps) => {
    const diskPrivileges = [...dps];
    const res = {
        public: [],
        private: [],
        share: [],
    };
    diskPrivileges
        .sort((a, b) => (a.resourceLabel > b.resourceLabel ? 1 : -1))
        .forEach(item => {
        const { resourceLabel, accessList } = item;
        if (resourceLabel === 'NETDISK_ORG') {
            res.public = [...accessList].sort((a, b) => (a.accessLabel > b.accessLabel ? 1 : -1)).map(item1 => item1.accessLabel);
        }
        if (resourceLabel === 'NETDISK_ACC') {
            res.private = [...accessList].sort((a, b) => (a.accessLabel > b.accessLabel ? 1 : -1)).map(item1 => item1.accessLabel);
        }
        if (resourceLabel === 'NETDISK_EXTERNAL_SHARE') {
            res.share = [...accessList].sort((a, b) => (a.accessLabel > b.accessLabel ? 1 : -1)).map(item1 => item1.accessLabel);
        }
    });
    return res;
};
